<template>
  <div>
    <p class="text">Last Time Updated: {{showDate}}</p>
  </div>
</template>
<script>
import axios from "@/api/axios-auth";

export default {
  name: 'LastTimeUpdated',
  props: ['selectedDate'],
  data() {
    return {
      data: null
    }
  },
  computed: {
    showDate() {
      if (this.data === null) {
        return "-"
      }
      return this.data[this.selectedDate]
    },
  },
  mounted() {
    axios
        .get('/settings/status')
        .then(response => (this.data = response.data))
  }
}
</script>

<style scoped>
.text {
  color: gray;
  text-align: right;
}
</style>
